// istanbul ignore file
import { translate, translateFormatter } from '@/core/localization/translate';
export const arrows = translate({
  "titleLeft": "Previous",
  "titleRight": "Next"
});
export const price = translate({
  "vatExclLabel": "EX.VAT",
  "vatInclLabel": "INC.VAT"
});
export const rating = {
  ariaLabel: (value: number) => translateFormatter<{
    value: number;
  }>([{
    "type": 1,
    "value": "value"
  }, {
    "type": 0,
    "value": " out of 5"
  }], undefined, undefined, "en").format({
    value
  }) as string,
  reviewsLabel: (value: number) => translateFormatter<{
    value: number;
  }>([{
    "type": 0,
    "value": "from "
  }, {
    "type": 6,
    "value": "value",
    "options": {
      "=1": {
        "value": [{
          "type": 7
        }, {
          "type": 0,
          "value": " review"
        }]
      },
      "other": {
        "value": [{
          "type": 7
        }, {
          "type": 0,
          "value": " reviews"
        }]
      }
    },
    "offset": 0,
    "pluralType": "cardinal"
  }], undefined, undefined, "en").format({
    value
  }) as string
};
export const pagination = translate({
  "previousPageAriaLabel": "Previous page",
  "nextPageAriaLabel": "Next page"
});
export const counter = translate({
  "decrementAriaLabel": "Decrease",
  "incrementAriaLabel": "Increase"
});
export const inputPhone = {
  countriesLabels: translate({
    "BE": "Belgium",
    "DE": "Germany",
    "ES": "Spain",
    "FR": "France",
    "GB": "United Kingdom",
    "IT": "Italy",
    "LU": "Luxembourg",
    "CH": "Switzerland"
  })
};